module.exports = __webpack_public_path__ + "img/1440.329c0098.jpg";